import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import Image from "../../assets/imgs/menu.png";
import Close from "../../assets/imgs/close.png";
const Header = css`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  padding: 15px 100px;
  z-index: 999;
  background: rgba(51, 51, 51, 0.9);
  @media (max-width: 1049px) {
    padding: 20px;
    width: 100%;
  }
`;
const Navigation = css`
  position: relative;

  @media (max-width: 1049px) {
    display: none;
  }
`;
const MenuBtn = css`
  @media (max-width: 1049px) {
    background: url(${Image}) no-repeat;
    position: absolute;
    background-size: 30px;
    width: 40px;
    height: 40px;
    margin: 10px 20px;
    cursor: pointer;
    color: white;
    right: 0;
  }
`;
export const Toggle = styled.div`
  width: 200px;
  right: 0;
  top: 20px;
  position: absolute;
`;
export const Menu = styled.div`
  @media (min-width: 1049px) {
    display: none;
  }
  text-align: center;
`;
export const CloseBtn = css`
  @media (max-width: 1049px) {
    background: url(${Close}) no-repeat;
    position: absolute;
    background-size: 30px;
    width: 40px;
    height: 40px;
    margin: 10px 20px;
    cursor: pointer;
    color: white;
    right: 0;
    top: 1;
    transition: 0.3s ease;
    background: filter invert(1);
    z-index: 999;
  }
`;
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ header }) => header && Header};
  ${({ navigation }) => navigation && Navigation};
  ${({ menuBtn }) => menuBtn && MenuBtn};
  ${({ closeBtn }) => closeBtn && CloseBtn};
`;
export const NavLinks = styled(NavLink)`
  padding: 5px 0;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: white;
  transition: 0.3s ease-in-out;
  :hover {
    background-color: #fff;
    color: #000;
    border-radius: 50px;
  }
`;
export const NavbarLink = styled(NavLink)`
  text-decoration: none;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 22px;
  margin-right: 30px;
  color: #fff;
  white-space: nowrap;
  :hover {
    transition: 0.5s ease-in-out;
    color: crimson;
  }
`;
export const Title = styled.div`
  color: #fff;
  font-size: 35px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
`;
export const NavbarItem = styled.div`
  width: 300px;
  background-color: #333;
  height: fit-content;
  padding: 100px 50px;
  position: absolute;
  top: -20px;
`;
